import io from "socket.io-client";
import { eventChannel } from "redux-saga";
import events from "./socket/eventHandlers";
import { call, put, take, delay, race } from "redux-saga/effects";

let socket = {}; // the socket object is stored here
let socketChanel = null; // the channel object created for socketReader

/**
 * Exposes a function that will pass messages *to* the server, hence the write in socketWriter
 */
export function socketWriter() {
  return (message) => {
    socket.emit("msg", message);
  };
}

export function connect() {
  const token = localStorage.getItem("_jwt");
  socket = io.connect("/", { path: "/socket.io", query: { token } });

  return new Promise((resolve) => {
    socket.on("connect", () => {
      // 2021-10-23: Added timeout to ensure that socket.io serverside is ready (see same in admin)
      setTimeout(() => resolve(socket), 500);
      //resolve(socket);
    });
    socket.on("disconnect", () => {
      resolve(socket);
    });
    socket.on("reconnected", () => {
      resolve(socket);
    });
    socket.on("error", () => {
      // 2021-11: removing the token creatd a lot of confusion for users (got logged out)
      //localStorage.removeItem("_jwt");
      socket.disconnect();
      //window.location = '/login'
    });

    events(); // register all eventHandlers
  });
}

/**
 * Connect to socket server
 *
 * This could happen in two ways: 1) At login and 2) at user hard refresh
 * Important is that no handleIO call is done BEFORE we init the socket, since they will go to /dev/null
 *
 * After we are done init the socket we return the socket
 *
 * mh 2019-06
 */
export function* connectSocket() {
  /**
   * `race` will take the first effect that finish.
   * I.e. in this situation we will timeout after 2 seconds of connection
   */

  const { timeout, connected } = yield race({
    connected: call(connect),
    timeout: delay(5000),
  });

  if (timeout) {
    alert(
      `Connection timedout. Please take a screenshot and send to Selfpoint support.\n${new Date()}`
    );
    console.error("Cannot connect!");
    return;
  }

  return connected;
}

/**
 * Create channel.
 *
 * > Note the sue of the emitWrapper, the emitWrapper converts the output from the eventHandelers into emits.
 */
function createChannelObject() {
  let emitWrapper;
  const channelObject = {
    socket: socket,
    channel: eventChannel((emit) => {
      emitWrapper =
        (func) =>
        (...params) => {
          const output = func(...params);
          if (Array.isArray(output)) {
            output.forEach(emit);
          } else if (output) {
            emit(output);
          }
        };
      return () => {};
    }),
  };
  channelObject.emitWrapper = emitWrapper;
  return channelObject;
}

/**
 * helper function to return channgel object. Will check if it exists or establish a new channel
 */
const getChannelObject = () => {
  if (!socketChanel) {
    const channel = createChannelObject();
    socketChanel = channel;
  }
  return socketChanel;
};

/**
 * Init the reader/incoming part of the socket.io server communication
 * Create a channel and listen to incoming messages and dispatch them to redux
 */
export function* socketReader(url) {
  const channel = getChannelObject(url).channel;
  while (true) {
    const action = yield take(channel);
    yield put(action);
  }
}

/**
 * helper function to addSocketHandler.
 *
 * > Used when register new effects in `sagas/index.js`
 */
export const addSocketHandler = (url, event, handler) => {
  const channel = getChannelObject(url);
  const wrappedHandler = channel.emitWrapper(handler);
  socket.on(event, wrappedHandler);
};
